import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { RcmCalendarView } from '../RcmCalendarView';

/**
 * RCM calendar (rcm-22 Day, rcm-23 Week). In RCM the calendar answers one
 * question — is each visit's insurance ready? — so it is a different view from
 * the Core scheduling grid (src/shared/ui CalendarGrid / WeekGrid), which RCM no
 * longer renders. No booking, no moving visits, no production numbers.
 *
 * View, date/week and the selected visit live in the URL
 * (/calendar?view=day&date=…&visit=… · ?view=week&week=…), read inside the
 * feature with useSearchParams (via useListUrlState) — the /calendar route is
 * unchanged.
 */
export function CalendarPage() {
  usePageTopBar({ breadcrumb: ['Calendar'] });
  return <RcmCalendarView />;
}
